import React, { useState } from "react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  Container,
  Grid,
  Button
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close"; // Import Close icon
import SearchIcon from "@mui/icons-material/Search";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { IMAGE_BASE_URL } from "../../config/constants";
import SearchDrawer from "./../SalesRecordPage/SearchDrawer";
import SearchWithDropdown from "./../SalesRecordPage/SearchWithDropdown";
import { FONT_FAMILY } from "../../config/themeConstants";
import HomeIcon from "@mui/icons-material/Home";
import LogoAnimation from "./LogoAnimation";
import { useMediaQuery } from "@mui/material";
import MovingMenu from "./MovingMenu";
import MobileDrawerMenu from "./MobileDrawerMenu";
const MenuBar = ({ allItems }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const navigate = useNavigate();

  const isSmallScreen = useMediaQuery("(max-width:600px)");

  // Toggle the mobile drawer
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Toggle the search modal
  const handleSearchModalToggle = () => {
    setIsSearchModalOpen(!isSearchModalOpen);
  };

  const menuItems = [
    { text: "Clearance Sale", href: "/jewels/list/clearance" },
    { text: "Holiday Sale", href: "/jewels/list/holiday" },
    { text: "All Items", href: "/jewels/list/All" },
    { text: "Necklace", href: "/jewels/list/Necklace" },
    { text: "Haarams", href: "/jewels/list/Haarams" },
    { text: "AD Stone", href: "/jewels/list/Adstone" },
    { text: "Bangles", href: "/jewels/list/BB" },
    { text: "Earrings", href: "/jewels/list/Earrings" },
    { text: "My Cart", href: "/jewels/bag" },
  ];
  const mobileMenuItems = [
    { text: "All Items", href: "/jewels/list/All" },
    { text: "Necklace", href: "/jewels/list/Necklace" },
    { text: "Haarams", href: "/jewels/list/Haarams" },
    { text: "AD Stone", href: "/jewels/list/Adstone" },
    { text: "Bangles", href: "/jewels/list/BB" },
    { text: "Earrings", href: "/jewels/list/Earrings" },
    { text: "My Cart", href: "/jewels/bag" },
  ];

  const drawerRef = useRef(null);

  // Animate menu text when the drawer opens
  useEffect(() => {
    if (mobileOpen && drawerRef.current) {
      anime.timeline({ loop: false }).add({
        targets: ".mobile-letter",
        translateY: ["1.2em", "0"],
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 750,
        delay: (el, i) => 70 * i,
      });
    }
  }, [mobileOpen]);

  return (
    <>
      {/* Top AppBar for desktop and mobile */}
      <AppBar
        position="fixed"
        color="default"
        sx={{
          backgroundColor: "#E0F7FA",
          boxShadow: "none",
          height: { xs: "60px", md: "80px" },
          borderBottom: "1px solid #ccc",
          paddingTop: { xs: "0px", lg: "0px" },
          paddingBottom: { xs: "0px", lg: "0px" },
        }}
      >
        <Container maxWidth="xxl">
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%" }}
            >
              {/* Logo (Left) */}
              <Grid item xs={3} md={2}>
                <Box
                  onClick={() => navigate("/jewels")}
                  sx={{ cursor: "pointer" }}
                >
                  <LogoAnimation />
                </Box>
              </Grid>

              {/* Search Bar (Middle, Hidden on Mobile) */}
              <Grid
                item
                md={2}
                sx={{
                  display: { xs: "none", md: "flex" },
                  justifyContent: "center",
                  marginTop: "15px",
                }}
              >
                <SearchWithDropdown
                  onSelectItem={(item) => {
                    if (item?.inventoryid) {
                      window.location.href = `/jewels/list/All/${item.inventoryid}?ref=view`;
                      setIsSearchModalOpen(false);
                    }
                  }}
                  itemsList={allItems}
                />
              </Grid>

              {/* Icons (Right) - Show Only on Mobile */}
              {isSmallScreen && (
                <Grid
                  item
                  xs={9}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                  >
                    <IconButton
                      color="inherit"
                      onClick={() => navigate("/jewels")}
                      sx={{ color: "black", mr: 1 }}
                    >
                      <HomeIcon sx={{ fontSize: 25 }} />
                    </IconButton>

                    <IconButton
                      color="inherit"
                      onClick={() => navigate("/jewels/bag")}
                      sx={{ mr: 1 }}
                    >
                      <ShoppingCartIcon sx={{ fontSize: 25 }} />
                    </IconButton>

                    <IconButton
                      color="inherit"
                      onClick={handleSearchModalToggle}
                      sx={{ mr: 1 }}
                    >
                      <SearchIcon sx={{ fontSize: 25 }} />
                    </IconButton>

                    <IconButton
                      color="inherit"
                      onClick={handleDrawerToggle}
                      sx={{ mr: -2 }}
                    >
                      <MenuIcon sx={{ fontSize: 35 }} />
                    </IconButton>
                  </Box>
                </Grid>
              )}

              {/* Desktop Menu (Aligned Properly) */}
              <Grid
                item
                md={8}
                sx={{
                  display: { xs: "none", md: "flex" },
                  justifyContent: "flex-end",
                }}
              >
                <MovingMenu menuItems={menuItems} />
              </Grid>
            </Grid>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Drawer for mobile */}
      {/* Mobile Drawer */}
      <MobileDrawerMenu
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        menuItems={mobileMenuItems}
      />

      {/* Modal for search component */}
      <SearchDrawer
        isOpen={isSearchModalOpen}
        onClose={handleSearchModalToggle}
        onSelectItem={(item) => {
          navigate(`/jewels/list/All/${item.inventoryid}?ref=view`);
          setIsSearchModalOpen(false);
        }}
        itemsList={allItems}
      />
      <Box
        sx={{
          mt: { xs: "60px", md: "80px" }, // Different mt values based on screen size
        }}
      ></Box>
      {/* Floating WhatsApp Chat Button */}
<Box
  sx={{
    position: "fixed",
    bottom: 20,
    right: 20,
    zIndex: 2000,
  }}
>
  <Button
    variant="contained"
    color="success"
    startIcon={<WhatsAppIcon />}
    href="https://wa.me/917907448913?text=Hi, I need help."
    target="_blank"
    rel="noopener noreferrer"
    sx={{
      borderRadius: "30px",
      textTransform: "none",
      fontWeight: 500,
      boxShadow: 3,
    }}
  >
    Chat
  </Button>
</Box>

    </>
  );
};

export default MenuBar;
